import CurrenciesApi from '@/services/shop/CurrenciesApi'

export interface CurrencyInterface {
  id: string
  name: string
  code: string
  symbol: string
  coins_per_currency: number
}

export class CurrencyDTO implements CurrencyInterface {
  id = ''
  name = ''
  code = ''
  symbol = ''
  coins_per_currency = 0
}

export default class Currency extends CurrencyDTO {
  static api = CurrenciesApi

  constructor(DTO: CurrencyDTO) {
    super()
    Object.assign(this, DTO)
  }
}
